'use strict';

window.IMG_NO_IMAGE = 'images/no-image.jpg';
window.URL_ICON_MARKER = 'http://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=•|';

window.DATE_FORMAT = 'dd/MM/yyyy';
window.DATE_WITHOUT_YEAR_FORMAT = 'dd/MM';
window.HOUR_FORMAT = 'HH:mm:ss';
window.DATE_HOUR_ENGLISH_FORMAT = 'yyyy-MM-dd HH:mm:ss';

window.MOMENT_DATE_ENGLISH_FORMAT = 'YYYY-MM-DD';

// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').factory('ContagensService', function($http, $q, $rootScope, MessagesService) {
  const createParams = function(filters) {
    const params = {
      tipo: filters.tipoContagem,
      propriedade: filters.propriedade,
      safra: filters.safra ? filters.safra.id : null,
      tp_insumo: filters.cultivar ? filters.cultivar.tpInsumo : null,
      cd_insumo: filters.cultivar ? filters.cultivar.idInsumo : null,
      estadio: filters.estadio ? filters.estadio.id : null,
      data_inicial: filters.dataInicial,
      data_final: filters.dataFinal
    };

    return params;
  };

  const getIds = function(details) {
    return details.markers.map(function(marker) {
      return marker.objeto.sincId;
    });
  };

  const send = function(method, url, dados) {
    return $http({
      method: method,
      headers: { 'Content-Type': 'application/json' },
      url: url,
      data: dados
    });
  };

  const sendPost = function(url, dados) {
    return send('POST', url, dados);
  };

  const sendPatch = function(url, dados) {
    return send('PATCH', url, dados);
  };

  return {
    desativarRegistro: function(action, registroId) {
      const url = `${SERVER + API_VERSION + action + registroId }/desativar`;
      return sendPatch(url);
    },
    changeCultivarStand: function(contagem, cultivar) {
      const dados = {
        contagem: {
          cultivar_id: cultivar.item_id
        }
      };
      const url = `${SERVER + API_VERSION }contagens/${contagem.sincId}/update_cultivar`;
      return sendPatch(url, dados);
    },

    changeCultivarProdutividade: function(produtividade, cultivar) {
      const dados = {
        produtividade: {
          cultivar_id: cultivar.item_id
        }
      };
      const url = `${SERVER + API_VERSION }produtividade_contagens/${produtividade.sincId}/update_cultivar`;
      return sendPatch(url, dados);
    },

    updateIdealDensity: function(parametros) {
      const params = {
        informacoes_cultivares: [{
          cd_safra: parametros.safra,
          cd_gleba: parametros.gleba.id,
          cd_atividade: parametros.atividade.id,
          tp_insumo: parametros.cultivar.tipo,
          cd_insumo: parametros.cultivar.id,
          populacao_ideal: parametros.populacaoIdeal
        }]
      };

      const url = `${SERVER + API_VERSION }informacoes_cultivares/1`;
      return sendPatch(url, params);
    },

    changeIdealDensity: function(scope) {
      const deferred = $q.defer();
      const _this = this;
      MessagesService.prompt('Valor da Densidade Ideal').then(function(data) {
        if (isNaN(data)) {
          deferred.reject('Valor inválido para a densidade ideal');
        } else {
          const parametros = {
            safra: scope.markers[0].objeto.params.safra_id,
            gleba: scope.gleba,
            atividade: scope.atividade,
            cultivar: scope.cultivar,
            populacaoIdeal: data
          };
          _this.updateIdealDensity(parametros).then(deferred.resolve, function() {
            deferred.reject('Não foi possível alterar o valor da densidade ideal');
          });
        }
      }, deferred.reject);

      return deferred.promise;
    },

    updateTargetProductivity: function(scope, targetProductivity) {
      const data = {
        informacoes_cultivares: [{
          cd_safra: scope.safra.id || null,
          cd_gleba: scope.gleba.id || null,
          cd_atividade: scope.atividade.id || null,
          tp_insumo: scope.cultivar.tipo || null,
          cd_insumo: scope.cultivar.id || null,
          produtividade_alvo: targetProductivity || null
        }]
      };
      const url = `${SERVER + API_VERSION }informacoes_cultivares/?safra=${ scope.safra.id}`;
      return sendPost(url, data);
    },

    updatePMS: function(details, pms) {
      const ids = getIds(details);

      const data = {
        pms: pms,
        ids: ids
      };
      const url = `${SERVER + API_VERSION }produtividade_contagens/pms`;
      return sendPatch(url, data);
    },

    updatePesoCapulho: function(details, peso) {
      const ids = getIds(details);

      const data = {
        peso_capulho: peso,
        ids: ids
      };
      const url = `${SERVER + API_VERSION }produtividade_contagens/peso_capulho`;
      return sendPatch(url, data);
    },

    updateCorrectionFactor: function(details, fator) {
      const ids = getIds(details);

      const data = {
        fator: fator,
        ids: ids
      };
      const url = `${SERVER + API_VERSION }produtividade_contagens/fator_correcao`;
      return sendPatch(url, data);
    },

    changeTargetProductivity: function(details) {
      const deferred = $q.defer();
      const _this = this;
      MessagesService.prompt('Valor da Produtividade Alvo').then(function(data) {
        if (isNaN(data) || !data) {
          deferred.reject('Valor inválido para a Produtividade Alvo');
        } else {
          _this.updateTargetProductivity(details, data).then(deferred.resolve, function() {
            deferred.reject('Não foi possível alterar o valor da produtividade alvo.');
          });
        }
      }, deferred.reject);

      return deferred.promise;
    },

    changePesos(details) {
      if (details.isAlgodao) {
        return this.changePesoCapulhos(details);
      }
      return this.changePMS(details);
    },

    changePMS: function(details) {
      const deferred = $q.defer();
      const _this = this;
      MessagesService.prompt('Valor do PMS').then(function(pms) {
        if (isNaN(pms) || !pms) {
          deferred.reject('Valor inválido para o PMS');
        } else {
          _this.updatePMS(details, pms).then(deferred.resolve, function() {
            deferred.reject('Não foi possível alterar o valor do PMS.');
          });
        }
      }, deferred.reject);

      return deferred.promise;
    },

    changePesoCapulhos(details) {
      const deferred = $q.defer();
      const _this = this;
      MessagesService.prompt('Peso do Capulho (gramas)').then(function(peso) {
        if (isNaN(peso) || !peso) {
          deferred.reject('Valor inválido para o peso do capulho');
        } else {
          _this.updatePesoCapulho(details, peso).then(deferred.resolve, function() {
            deferred.reject('Não foi possível alterar o peso do capulho.');
          });
        }
      }, deferred.reject);

      return deferred.promise;
    },

    changeCorrectionFactor: function(details) {
      const deferred = $q.defer();
      const _this = this;
      MessagesService.prompt('Valor do Fator de Correção').then(function(factor) {
        if (isNaN(factor) || !factor) {
          deferred.reject('Valor inválido para o Fator de Correção');
        } else {
          _this.updateCorrectionFactor(details, factor).then(deferred.resolve, function() {
            deferred.reject('Não foi possível alterar o valor do Fator de Correção.');
          });
        }
      }, deferred.reject);

      return deferred.promise;
    },

    changeStandConfigurations(configurations) {
      const url = `${SERVER + API_VERSION }contagens/${ configurations.id }/change_configurations`;
      const data = {
        contagem: configurations
      };
      return sendPatch(url, data);
    },

    getProductivityStadiums: function(filters) {
      const url = `${SERVER + API_VERSION }produtividade_estadios`;
      const gleba = filters.gleba;
      filters = createParams(filters);
      filters.gleba = gleba;
      return $http.get(url, { params: filters });
    },

    getWheatAverages: function(contagens, area) {
      const sumReduce = function(list, attribute) {
        return list.reduce(function(sum, line) {
          return sum + line[attribute];
        }, 0);
      };

      const totalSpikes = sumReduce(contagens, 'spike');
      const totalGrains = sumReduce(contagens, 'grains');
      const totalSpikelets = sumReduce(contagens, 'spikelet');

      return {
        averageSpikelets: totalSpikelets / contagens.length,
        averageGrains: totalGrains / contagens.length,
        averageSpikes: totalSpikes / contagens.length,
        totalSpikes: totalSpikes,
        spikesSquareMeters: area ? totalSpikes / area : 0
      };
    },

    getCornClassifications: function(samples) {
      return Object.values(samples.reduce(function(result, sample) {
        _.each(sample, function(value, key) {
          value.classification.weight = Number(value.classification.weight);
          result[key] = value.classification;
        });
        return result;
      }, {}));
    }
  };
});
